import policy from "./language_policy.json";

export function isTechnicalRoute(route = []) {
    if (["Form", "List", "Tree"].includes(route[0])) {
        return policy.technical_doctypes.includes(route[1]);
    }
    return policy.technical_pages.includes(route[0]) || policy.technical_route_prefixes.includes(route[0]);
}

export function isTechnicalRequest(args = {}) {
    let doc = args.doc || args.docs;
    if (typeof doc === "string") {
        try { doc = JSON.parse(doc); } catch { doc = null; }
    }
    return policy.technical_doctypes.includes(args.doctype || args.dt || doc?.doctype);
}

// Desk and form bundles load separate module instances: share only this synchronous stack.
const getScopes = () => (window.frappe.__language_area_scopes ||= []);

function withLanguageArea(technical, callback) {
    const scopes = getScopes();
    scopes.push(technical);
    try { return callback(); } finally { scopes.pop(); }
}

export function areaLocale() { return window.frappe?.boot?.ru_base_ui_mode === "original-en" ? "en" : (window.frappe?.boot?.lang || "en"); }

export function documentTranslator(doctype) {
    const technical = policy.technical_doctypes.includes(doctype);
    return (...args) => withLanguageArea(technical, () => window.__(...args));
}

export function scopeQuickEntry(instance, doctype) {
    const technical = policy.technical_doctypes.includes(doctype);
    const seen = new Set();
    for (let proto = Object.getPrototypeOf(instance); proto && proto !== Object.prototype; proto = Object.getPrototypeOf(proto)) {
        for (const name of Object.getOwnPropertyNames(proto)) {
            if (name === 'constructor' || seen.has(name)) continue;
            seen.add(name);
            const method = Object.getOwnPropertyDescriptor(proto, name)?.value;
            if (typeof method !== 'function') continue;
            instance[name] = (...args) => {
                return withLanguageArea(technical, () => method.apply(instance, args));
            };
        }
    }
}

export function withWorkLanguage(callback) {
    return withLanguageArea(false, callback);
}

export function inEnglishArea() {
    const mode = window.frappe?.boot?.ru_base_ui_mode || "zoned-ru";
    document.documentElement.dataset.ru_baseUiMode = mode;
    if (mode === "original-en") return true;
    return areaLocale().split(/[-_]/)[0] === "en";
}

export function withSettingsLanguage(callback) { return withLanguageArea(true, callback); }
